import { render, staticRenderFns } from "./TheMainNavbarHorizontal.vue?vue&type=template&id=1a1f5bc1"
import script from "./TheMainNavbarHorizontal.vue?vue&type=script&lang=js"
export * from "./TheMainNavbarHorizontal.vue?vue&type=script&lang=js"
import style0 from "./TheMainNavbarHorizontal.vue?vue&type=style&index=0&id=1a1f5bc1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports